import { parseResourceFileToObj } from '&/utils/common';

const modulesFiles = require.context('@/locales/en-US', true, /\.js$/);

const lang = parseResourceFileToObj(modulesFiles);

export default lang;
